import { useCallback } from 'react';

import {
    useFantasyCollectionValidityStore,
    useFantasyDiscoverSectionTab,
    useFantasyLineupStore,
    useFantasyMetadataStore,
    useFantasyRecentPicks,
    useFantasySubmissionStore,
    useFantasySummaryStore,
} from '@app/store/zustand';

export const useClearFantasyContents = () => {
    const clearSummary = useFantasySummaryStore((state) => state.clearSummary);
    const clearRecentCollections = useFantasyRecentPicks((state) => state.clearRecentCollections);
    const clearLineupItems = useFantasyLineupStore((state) => state.clearLineupItems);
    const clearCollections = useFantasyCollectionValidityStore((state) => state.clearCollections);
    const clearGameMetadata = useFantasyMetadataStore((state) => state.clearGameMetadata);
    const resetGameSubmissionState = useFantasySubmissionStore((state) => state.resetGameSubmissionState);
    const resetTab = useFantasyDiscoverSectionTab((state) => state.resetTab);
    return useCallback(async () => {
        clearLineupItems();
        clearGameMetadata();
        clearCollections();
        clearRecentCollections();
        clearSummary();
        resetTab();
        resetGameSubmissionState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
